/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RandomVideoResponse
 */
export interface RandomVideoResponse {
    /**
     * 
     * @type {string}
     * @memberof RandomVideoResponse
     */
    videoId: string;
}

/**
 * Check if a given object implements the RandomVideoResponse interface.
 */
export function instanceOfRandomVideoResponse(value: object): value is RandomVideoResponse {
    if (!('videoId' in value) || value['videoId'] === undefined) return false;
    return true;
}

export function RandomVideoResponseFromJSON(json: any): RandomVideoResponse {
    return RandomVideoResponseFromJSONTyped(json, false);
}

export function RandomVideoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RandomVideoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'videoId': json['video_id'],
    };
}

export function RandomVideoResponseToJSON(json: any): RandomVideoResponse {
    return RandomVideoResponseToJSONTyped(json, false);
}

export function RandomVideoResponseToJSONTyped(value?: RandomVideoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'video_id': value['videoId'],
    };
}

